import React, { forwardRef } from "react";
import styles from "../subjects.module.css";
import { useSelector } from "react-redux";

const AddSubjectMenu = (props, ref) => {
  const { router } = props;
  const user_data = useSelector((state) => state.user.userData);

  const study_id = useSelector((state) => state.study.active_study_id);

  const study_name = user_data.studies.find((s) => s.id === study_id)?.name;

  return (
    <div className={styles.hover_menu} ref={ref}>
      <div
        className={styles.menu_button}
        onClick={() => {
          if ([5, 6].includes(user_data.active_study_id)) {
            router.navigate("/confirm_add_subject");
          } else if ([7].includes(user_data.active_study_id)) {
            router.navigate("/eligibility/interact5");
          } else {
            router.navigate("/select_domain");
          }
        }}
      >
        {`Add Subject to ${study_name}`}
      </div>
    </div>
  );
};

export default forwardRef(AddSubjectMenu);
